import React from "react";

export default function SignUp() {
   return <p>Sign Up</p>;
}
